import { useEffect, useRef, useState } from "react";

import { v4 as uuidv4 } from "uuid";

type MapOptions = google.maps.MapOptions;

const useMap = (opts?: MapOptions, defaultMapElementId?: string) => {
  const mapElementId = useRef<string>(defaultMapElementId ?? uuidv4());
  const [map, setMap] = useState<google.maps.Map | undefined>(undefined);
  useEffect(
    () => {
      const mapElement = document.getElementById(mapElementId.current) as HTMLElement;
      if (!mapElement) {
        return;
      }

      setMap(new google.maps.Map(mapElement, opts));
      return () => {
        setMap(undefined);
      };
    },
    // disable deps check, we don't want to rebuild the map when the `opts` arg change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  return { map, mapElementId: mapElementId.current };
};

export default useMap;
